import { render, staticRenderFns } from "./ContactDeBase.vue?vue&type=template&id=2c941d69"
import script from "./ContactDeBase.vue?vue&type=script&lang=js"
export * from "./ContactDeBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports